export const MAX_ROTATION_ANGLE = 360;
